import React from 'react'
import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material'

const DropDown = ({
  placeholder,
  menuItems,
  className = '',
  placeholderClassName = '',
  borderColor = '!border-[#FFCA84]',
  value,
  setValue,
  selectedItemClassName = '',
  renderIcon,
  renderItem,
  shouldRenderItemSelected = true,
  autoComplete = false,
  ...props
}) => {
  const handleChange = (event) => {
    setValue(event.target.value)
  }

  return (
    <FormControl
      fullWidth
      className={`dropdownMenuView2 !border-[1px] !border-solid ${borderColor} focus:!border-[#f67443] focus:ring-[#F67443] rounded-lg bg-white ${className}`}
    >
      <Select
        IconComponent={
          renderIcon ||
          (() => (
            <div aria-hidden="true" className="pr-3">
              <img width={10} height={10} src="/assets/image/up_down.svg" alt="" />
            </div>
          ))
        }
        id="simple-select"
        value={value}
        displayEmpty
        onChange={handleChange}
        input={
          <OutlinedInput
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
              },
            }}
            // disableUnderline={true}
          />
        }
        renderValue={(selected) => {
          if (!selected) {
            return <span className={`text-[#F67443] ${placeholderClassName}`}>{placeholder}</span>
          }

          if (renderItem && shouldRenderItemSelected) {
            return renderItem(menuItems.find((e) => e.value === value))
          }

          return (
            <span className={`text-[#F67443] ${selectedItemClassName}`}>
              {menuItems.find((e) => e.value === value)?.label || value}
            </span>
          )
        }}
        inputProps={{ 'aria-label': 'Sort options' }}
        {...props}
      >
        {menuItems?.map((menuItem, index) => (
          <MenuItem
            className="!text-[#F67443]"
            key={menuItem.key || `${menuItem.value}_${index}`}
            value={menuItem.value}
          >
            {renderItem ? renderItem(menuItem) : menuItem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default DropDown
